import {Skeleton} from "@mui/material";


const NotificationConfigItemPlaceholder = () => {

    return <Skeleton height={120} />
}


export default NotificationConfigItemPlaceholder;